//
//
//
//
//
//
import Activity from 'components/Activity';
export default {
  props: {
    activities: Array
  },
  components: {
    Activity: Activity
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  computed: {}
};